import React from "react"
import ReCAPTCHA from "react-google-recaptcha"

const siteKey = process.env.GATSBY_RECAPTCHA_SITE_KEY

export default ({ setFieldValue, status }) => {
  if (!siteKey) {
    return (
      <div role="alert" style={{ color: "red", margin: "12px 0" }}>
        This form is temporarily unavailable. Please try again later.
      </div>
    )
  }

  return (
    <div style={{ margin: "12px 0" }}>
      <ReCAPTCHA
        sitekey={siteKey}
        onChange={value =>
          setFieldValue("g-recaptcha-response", value || "", false)
        }
        onExpired={() =>
          setFieldValue("g-recaptcha-response", "", false)
        }
        onErrored={() =>
          setFieldValue("g-recaptcha-response", "", false)
        }
      />
      {status && status.message === "captcha-required" && (
        <div role="alert" style={{ color: "red", fontSize: 12 }}>
          Please verify that you are not a robot.
        </div>
      )}
    </div>
  )
}
